export default {
    state: {
        arr: {}
    },
    getters:{
        FIN: state=> {
            return state.arr
        }
    },
    mutations: {
        SET_FIN: (state,payload) =>{
            state.arr=payload
            state.arr.actual='1'
        },
        SET_FIN_ACTUAL: (state,actual) =>{
            state.arr.actual=actual
        }
    },
    actions: {
        SET_FIN: (context, payload) => {
             context.commit('SET_FIN',payload)
        },
        SET_FIN_ACTUAL: (context, actual) => {
            context.commit('SET_FIN_ACTUAL',actual)
        }
    },

}